<template>
  <div :class="findWrapperClass"></div>
</template>

<script>
export default {
  props: ["portal", "form", "wrapper"],
  mounted() {
    if( typeof( hbspt ) === 'undefined' ){
      this.$loadScript("https://js.hsforms.net/forms/v2.js")
        .then(res => {
          this.initForm();
        })
        .catch(err => {
          console.error("Error occured while loading the HubSpot form.");
        });
    } else {
      this.initForm();
    }
  }, 
  methods: {
    initForm(){
      hbspt.forms.create({
        portalId: this.portal,
        formId: this.form,
        target: ( !!this.wrapper ) ? '.' + this.wrapper : ".hubspot-contact-form",
      });
    }
  },
  computed: {    
  	findWrapperClass() {
  		return this.wrapper || 'hubspot-contact-form';
  	}
  }
};
</script>


// WEBPACK FOOTER //
// assets/js/components/Hubspot.vue